module.exports = __webpack_public_path__ + "img/maciej_wenerski.b97a01ad.jpeg";